import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconPaletteType, IconType } from '@cf/core';
import { IconComponent } from '@cf/shared/ui/icons';
import { TextComponent } from '@cf/shared/ui/typography';

@Component({
  selector: 'cf-notification-container',
  imports: [CommonModule, IconComponent, TextComponent],
  template: `
    <div class="wrapper" [style.max-width]="containerMaxWidth">
      <div class="icon">
        <cf-icon size="xl" [color]="iconColor" [icon]="icon"></cf-icon>
      </div>
      <span *ngIf="heading" class="tw:font-medium tw:text-lg">{{ heading }}</span>
      <div class="description" *ngIf="description">
        <cf-text color="grey-70">{{ description }}</cf-text>
      </div>
      <div class="action">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./notification-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationContainerComponent {
  @Input() heading!: string;

  @Input() description!: string;

  @Input() icon: IconType = 'ok-status';

  @Input() iconColor: IconPaletteType = 'none';

  @Input() containerMaxWidth = '100%';
}
